// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'
import {
  fetchAndAddFrequencySettings,
  fetchAndAddRadioSettings,
  fetchAndAddRegulatorySettings,
} from 'redux/modules/domain'

// fetches regulatory, radio and antenna settings
// if they are not already loaded in redux

const getPathSettings = () => (dispatch, getState) => (
  dispatch(loadingToggler(
    () => {
      const shouldLoad = settingsPath => !getState().domain.getIn(settingsPath).size
      const settingsToFetch = []

      if (shouldLoad(['regulatorySettings', 'bands'])) {
        settingsToFetch.push(dispatch(fetchAndAddRegulatorySettings()))
      }

      if (shouldLoad(['radioSettings', 'statuses'])) {
        settingsToFetch.push(dispatch(fetchAndAddRadioSettings()))
      }

      if (shouldLoad(['frequencySettings', 'polarizations'])) {
        settingsToFetch.push(dispatch(fetchAndAddFrequencySettings()))
      }

      return Promise.all(settingsToFetch)
    }))
)

export default getPathSettings
